import React, { useState, useContext } from "react";
import { FormContext } from "../context/FormContext";
import styled from "styled-components";
import { motion } from "framer-motion";
import PlanArrow from "../images/arrow_2.svg";
import PlanWOM250GBWOM62Img from "../images/planes/plan-wom-250gb-wom62.svg";
import PlanMas400GBImg from "../images/planes/plan-mas-400gb.svg";
import PlanMas400GBWOM72Img from "../images/planes/plan-mas-400gb-wom72.svg";
import PlanWOMGBLibreImg from "../images/planes/plan-wom-gb-libre.svg";
import PlanMasLibreImg from "../images/planes/plan-mas-libre.svg";
import PlanMasGBLibreImg from "../images/planes/plan-mas-gb-libre.svg";
import PlanMasGBLibrePlusImg from "../images/planes/plan-mas-gb-libre-plus.svg";
import PlanAcumula200GigasImg from "../images/planes/plan-acumula-200-gigas.svg";
import PlanAcumula300GbImg from "../images/planes/plan-acumula-300gb.svg";
import PlanAcumula400GBImg from "../images/planes/plan-acumula-400gb.svg";
import PlanWOM400GBWOM64Img from "../images/planes/plan-wom-400gb-wom64.svg";
import PlanWOM250GBImg from "../images/planes/plan-wom-250gb.svg";
import PlanWOM400GBImg from "../images/planes/plan-wom-400gb.svg";
import PlanWOMLibreImg from "../images/planes/plan-wom-libre.svg";
import PlanMas250GBImg from "../images/planes/plan-mas-250gb.svg";
import PlanMas250GBWOM71Img from "../images/planes/plan-mas-250gb-wom71.svg";
import PlanMas250GigasImg from "../images/planes/plan-mas-250-gigas.svg";
import PlanMas400GigasImg from "../images/planes/plan-mas-400-gigas.svg";
import PlanMasGigasLibresImg from "../images/planes/plan-mas-gigas-libres.svg";
import PlanMasGigasLibresPlusImg from "../images/planes/plan-mas-gigas-libres-plus.svg";
import WOMmas400GigasImg from "../images/planes/wom-mas-400-gigas.svg";
import WOMmas400GigasTacticoImg from "../images/planes/wom-mas-400-gigas-tactico.svg";
import WOMmas600GigasImg from "../images/planes/wom-mas-600-gigas.svg";
import WOMmasLibreImg from "../images/planes/wom-mas-libre.svg";
import WOMmasLibrePlusImg from "../images/planes/wom-mas-libre-plus.svg";
import PlanWOM150GigasImg from "../images/planes/plan-wom-150-gigas.svg";
import PlanOfertaWOM150GbImg from "../images/planes/plan-oferta-wom-150gb.svg";
import PlanOfertaWOMMas300GbImg from "../images/planes/plan-oferta-wom-mas-300gb.svg";
import PlanOfertaWOMMas450GbImg from "../images/planes/plan-oferta-wom-mas-450gb.svg";
import PlanOfertaWOMMasGbLibresImg from "../images/planes/plan-oferta-wom-mas-gblibres.svg";
import PlanOfertaWOMMasGbLibresPlusImg from "../images/planes/plan-oferta-wom-mas-gblibres-plus.svg";
import WOM7950dctoImg from "../images/planes/wom-7950-dcto.svg";
import PilotoMVSPlanWOM150GigasImg from "../images/planes/plan-piloto-mvs-wom-150-gigas.svg";
import PlanWOM150GigasWOM86Img from "../images/planes/plan-wom-150-gigas-wom86.svg";
import PlanGigasLibresWOM115Img from "../images/planes/plan-gigas-libres-wom115.svg";
import PlanGigasLibresPlusWOM116Img from "../images/planes/plan-gigas-libres-plus-wom116.svg";

const RequestContainerMob = styled(motion.div)`
  width: 96%;
  margin: 20px auto 0;
  overflow: hidden;
  .request-heading {
    height: 44px;
    background-color: #76489b;
    padding: 10px 20px;
    border-radius: 8px 8px 0 0;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    p {
      color: #ffffff;
      font-size: 16px;
      line-height: 16px;
      font-weight: 500;
      text-transform: uppercase;
    }
    img {
      transition: transform 0.3s;
      transform: rotate(0deg);
      &.active {
        transform: rotate(180deg);
      }
    }
  }
  .allRadius {
    border-radius: 8px;
  }
  .request-plan {
    background-color: #ffffff;
    border-radius: 0px 0px 8px 8px;
    pointer-events: none;
    .container-imgplan {
      padding: 20px;
      img {
        display: block;
        margin: 0 auto;
        box-shadow: 0px 6px 12px rgba(56, 20, 81, 0.15);
        border-radius: 8px;
      }
      &.imgplan-custom{
        img{
          border-radius: 8px;
        }
      }
    }
  }
`;

const RequestPlanMob = () => {
  const { formData } = useContext(FormContext);
  const [open, setOpen] = useState(true);

  const variantsOpen = {
    open: {
      maxHeight: 500,
      opacity: 1,
      transition: { duration: 0.3 },
    },
    close: {
      maxHeight: 0,
      opacity: 0,
      transition: { duration: 0.3 },
    },
  };

  return (
    <RequestContainerMob>
      <div
        className={!open ? "request-heading" : "allRadius request-heading"}
        onClick={() => setOpen(!open)}
      >
        <p>estás solicitando...</p>
        <img className={open ? "active" : ""} src={PlanArrow} alt="arrow" />
      </div>
      <motion.div
        className="request-plan"
        variants={variantsOpen}
        initial="close"
        animate={open ? "close" : "open"}
      >
        {          
          <div className="container-imgplan imgplan-custom">
            {formData.selectedPlan === "PlanWOM250GB-WOM62" && ( <img src={PlanWOM250GBWOM62Img} alt="plan wom 250gb wom62" />)}
            {formData.selectedPlan === "PlanMas250GB" && ( <img src={PlanMas250GBImg} alt="plan mas 250gb" />)}
            {formData.selectedPlan === "PlanMas250GB-WOM71" && ( <img src={PlanMas250GBWOM71Img} alt="plan mas 250gb wom71" />)}
            {formData.selectedPlan === "PlanWOM400GB-WOM64" && ( <img src={PlanWOM400GBWOM64Img} alt="plan wom 400gb wom64" />)}
            {formData.selectedPlan === "PlanWOMGBLibre" && ( <img src={PlanWOMGBLibreImg} alt="plan wom gb libre" />)}
            {formData.selectedPlan === "PlanMasLibre" && ( <img src={PlanMasLibreImg} alt="plan mas libre" />)}
            {formData.selectedPlan === "PlanMasGBLibre" && ( <img src={PlanMasGBLibreImg} alt="plan mas gb libre" />)}
            {formData.selectedPlan === "PlanMasGBLibrePlus" && ( <img src={PlanMasGBLibrePlusImg} alt="plan mas gb libre +" />)}
            {formData.selectedPlan === "PlanAcumula200Gigas" && ( <img src={PlanAcumula200GigasImg} alt="plan acumula 200 gigas" />)}
            {formData.selectedPlan === "PlanAcumula300GB" && ( <img src={PlanAcumula300GbImg} alt="plan acumula 300gb" />)}
            {formData.selectedPlan === "PlanAcumula400GB" && ( <img src={PlanAcumula400GBImg} alt="plan acumula 400gb" />)}
            {formData.selectedPlan === "PlanMas400GB" && ( <img src={PlanMas400GBImg} alt="plan mas 400gb" />)}
            {formData.selectedPlan === "PlanMas400GB-WOM72" && ( <img src={PlanMas400GBWOM72Img} alt="plan mas 400gb wom72" />)}
            {formData.selectedPlan === "PlanWOM250GB" && ( <img src={PlanWOM250GBImg} alt="plan wom 250gb" />)}
            {formData.selectedPlan === "PlanWOM400GB" && ( <img src={PlanWOM400GBImg} alt="plan wom 400gb" />)}
            {formData.selectedPlan === "PlanWOMLibre" && ( <img src={PlanWOMLibreImg} alt="plan wom libre" />)}
            {formData.selectedPlan === "PlanMas250Gigas" && ( <img src={PlanMas250GigasImg} alt="plan mas 250 gigas" />)}
            {formData.selectedPlan === "PlanMas400Gigas" && ( <img src={PlanMas400GigasImg} alt="plan mas 400 gigas" />)}
            {formData.selectedPlan === "PlanMasGigasLibres" && ( <img src={PlanMasGigasLibresImg} alt="plan mas gigas libres" />)}
            {formData.selectedPlan === "PlanMasGigasLibresPlus" && ( <img src={PlanMasGigasLibresPlusImg} alt="plan mas gigas libres +" />)}
            {formData.selectedPlan === "WOMmas400Gigas" && ( <img src={WOMmas400GigasImg} alt="wom mas 400 gigas" />)}
            {formData.selectedPlan === "WOMmas400GigasTactico" && ( <img src={WOMmas400GigasTacticoImg} alt="wom mas 400 gigas" />)}
            {formData.selectedPlan === "WOMmas600Gigas" && ( <img src={WOMmas600GigasImg} alt="wom mas 600 gigas" />)}
            {formData.selectedPlan === "WOMmasLibre" && ( <img src={WOMmasLibreImg} alt="wom mas libre" />)}
            {formData.selectedPlan === "WOMmasLibrePlus" && ( <img src={WOMmasLibrePlusImg} alt="wom mas libre +" />)}
            {formData.selectedPlan === "PlanWOM150Gigas" && ( <img src={PlanWOM150GigasImg} alt="plan wom 150 gigas" />)}
            {formData.selectedPlan === "OfertaWOM150gb" && ( <img src={PlanOfertaWOM150GbImg} alt="oferta wom 150gb" />)}
            {formData.selectedPlan === "OfertaWOMmas300gb" && ( <img src={PlanOfertaWOMMas300GbImg} alt="oferta wom mas 300gb" />)}
            {formData.selectedPlan === "OfertaWOMmas450gb" && ( <img src={PlanOfertaWOMMas450GbImg} alt="oferta wom mas 450gb" />)}
            {formData.selectedPlan === "OfertaWOMmasgblibres" && ( <img src={PlanOfertaWOMMasGbLibresImg} alt="oferta wom gb libres" />)}
            {formData.selectedPlan === "OfertaWOMmasgblibresplus" && ( <img src={PlanOfertaWOMMasGbLibresPlusImg} alt="oferta wom gb libres +" />)}
            {formData.selectedPlan === "WOM7950dcto" && ( <img src={WOM7950dctoImg} alt="WOM 7950dcto" />)}
            {formData.selectedPlan === "WOM7950dctoM" && ( <img src={WOM7950dctoImg} alt="WOM 7950dctoM" />)}
            {formData.selectedPlan === "PILOTO_PlanWOM150Gigas" && ( <img src={PilotoMVSPlanWOM150GigasImg} alt="Plan WOM 150 Gigas" />)}
            {formData.selectedPlan === "PlanWOM150Gigas-WOM86" && ( <img src={PlanWOM150GigasWOM86Img} alt="Plan WOM 150 Gigas WOM86" />)}
            {formData.selectedPlan === "PlanGBLibre" && ( <img src={PlanGigasLibresWOM115Img} alt="Plan Gigas Libres WOM115" />)}
            {formData.selectedPlan === "PlanGBLibrePlus" && ( <img src={PlanGigasLibresPlusWOM116Img} alt="Plan Gigas Libres Plus WOM116" />)}
          </div> 
        }
        
      </motion.div>
    </RequestContainerMob>
  );
};

export default RequestPlanMob;
